import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MaterialModule } from '../../shared/material.module';
import { Settings, SettingsService } from '../../services/settings.service';
import { ThemePickerComponent } from '../theme/theme-picker.component';
import { MatDialog } from '@angular/material/dialog';
import { CardsService } from 'src/app/services/cards.service';
import { BreadcrumbComponent } from 'src/app/components/shared/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-settings',
  standalone: true,
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, BreadcrumbComponent],
})
export class SettingsComponent implements OnInit {
  settingsForm!: FormGroup;
  settings: Settings | null = null;

  loading = false;
  error = '';
  success = '';

  constructor(
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private dialog: MatDialog,
    private cardsService: CardsService,
  ) {}

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this.loading = true;
    this.error = '';
    this.settingsService.getSettings().subscribe({
      next: (res) => {
        this.settings = res;
        this.settingsForm = this.fb.group({
          themeColor: [res.themeColor || 'default'],
          language: [res.language || 'en'],
          notifications: [res.notifications ?? true],
          isDarkMode: [res.isDarkMode ?? false],
          logoUrl: [res.logoUrl || ''],
        });
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching settings:', err);
        this.error = 'Failed to load settings';
        this.loading = false;
      },
    });
  }

  // current card id (from your CardsService)
  get currentCardId(): string | null {
    return this.cardsService.selectedCard()?.id ?? null;
  }

openThemePicker(): void {
  const cardId = this.currentCardId;
  if (!cardId) {
    this.error = 'Card ID is missing. Cannot select theme.';
    console.warn('Card ID not available for theme selection');
    return;
  }

    const dialogRef = this.dialog.open(ThemePickerComponent, {
    width: '700px',        // compact width
    maxWidth: '95vw',      // never exceed viewport width
    height: 'auto',        // height adjusts to content
    maxHeight: '90vh',     // prevent overflow
    panelClass: 'theme-picker-dialog',
    autoFocus: false,
  });

  dialogRef.componentInstance.cardId = cardId;

  dialogRef.componentInstance.themeSelected.subscribe((theme) => {
    const gradient = `linear-gradient(135deg, ${theme.startColor}, ${theme.endColor})`;
    this.settingsForm.patchValue({ themeColor: gradient });

    // Apply + persist
    dialogRef.componentInstance.apply();
    dialogRef.close();
  });
}





  saveSettings(): void {
    if (!this.settingsForm.valid) return;

    this.loading = true;
    this.error = '';
    this.success = '';
    this.settingsService.updateSettings(this.settingsForm.value).subscribe({
      next: (updated) => {
        this.settings = updated;
        this.success = 'Settings updated successfully!';
        this.loading = false;
      },
      error: (err) => {
        console.error('Error updating settings:', err);
        this.error = 'Failed to update settings';
        this.loading = false;
      },
    });
  }

  resetSettings(): void {
    if (!confirm('Are you sure you want to delete your settings?')) return;

    this.loading = true;
    this.error = '';
    this.settingsService.deleteSettings().subscribe({
      next: () => {
        this.settings = null;
        this.settingsForm.reset();
        this.success = 'Settings deleted, defaults will be applied next time.';
        this.loading = false;
      },
      error: (err) => {
        console.error('Error deleting settings:', err);
        this.error = 'Failed to delete settings';
        this.loading = false;
      },
    });
  }
}
